import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src//elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, saleOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const UnsoldAssetsReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();
  const [saleId, setSaleId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'unsold-assets-report',
      params: { 'sale-id': saleId, 'seller-id': sellerId },
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Unsold Assets Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Sale:</Text>
      <SearchableSelect
        placeholder="All currently unsold assets"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
        searchHint={false}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
}

export default UnsoldAssetsReport;
